import React from 'react'
import { Box, Link, Stack, Text } from '@machobear/design-system'
import { useTranslation } from 'react-i18next'

const EmptyDetachedList: React.FC = () => {
  const { t } = useTranslation()

  return (
    <Box display="flex" justifyContent="center" alignItems="center" height="full">
      <Stack align="center" space="medium">
        <Text size="standard" weight="medium">
          {t('l.settings.view.auto_reply.no_listings_available', 'No listings available')}
        </Text>
        <Box style={{ width: '250px' }} maxWidth="small">
          <Text size="small" weight="regular" align={'center'}>
            {t(
              'l.settings.view.no_available_listings.text',
              'You currently have no available listings, try creating a new listing to save time responding to inquiries.'
            )}
          </Text>
        </Box>

        <Link href={`/listing/create`}>
          <Text size="medium" tone="link">
            {t('l.listings.empty_listings.create_listing', 'Create a listing')}
          </Text>
        </Link>
      </Stack>
    </Box>
  )
}

export default EmptyDetachedList
